var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.detailsComponent,_vm._g(_vm._b({tag:"component",attrs:{"scrollable":"","max-width":"600"}},'component',Object.assign({}, _vm.$attrs, _vm.$props),false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }